import { selector } from "recoil"
import { roomSelector } from "../atoms/room"
import { someHaveOnDeviceSelector } from "./some-have-on-selectors"

export const shoppableVideosSelector = selector<boolean>({
  key: "shoppableVideosSelector",
  get: ({ get }) => {
    return get(roomSelector)?.enableShoppableVideos
  }
})

export const moderatorRequiredShoppableVideosSelector = selector<boolean>({
  key: "moderatorRequiredShoppableVideosSelector",
  get: ({ get }) => {
    return (
      get(roomSelector).enableShoppableVideos &&
      !get(someHaveOnDeviceSelector) &&
      !get(roomSelector)?.moderatorRequired
    )
  }
})
